import React, { useState, useEffect } from "react";
import { Modal, Input, Button, message } from "antd";

const PhoneNumberModal = ({ visible, onOk, onCancel, recovery = false, recoveryCode, onNewPhoneCode = ()=>{} }) => {
  const [inputValue, setInputValue] = useState("")

  const handleOk = () => {
    if (!inputValue) {
      message.error("Se requiere un valor para continuar.");
      return;
    }

     // Se envia el código de autenticación
    if ( recoveryCode) {
      onNewPhoneCode(inputValue.trim())
      return
    }

    // Se registra el número de telefono
    let formattedPhoneNumber = inputValue.replace(/\D/g, "");
    if (!formattedPhoneNumber.startsWith("52")) {
      formattedPhoneNumber = "52" + formattedPhoneNumber;
    }
    formattedPhoneNumber = "+" + formattedPhoneNumber;
    onOk(formattedPhoneNumber)
  }

  useEffect(() => {
    setInputValue("")
  }, [recoveryCode])

  return (
    <Modal
      title="Ingresa tu número de teléfono"
      onOk={handleOk}
      onCancel={onCancel}
      open={visible}
    >
      {recovery ? (
        <p>
          {recoveryCode
            ? "Ingresa el código enviado a tu teléfono"
            : "Ingresa tu nuevo número de teléfono"}
        </p>
      ) : (
        <p>
          Por razones de seguridad, necesitamos tu número de teléfono para
          activar la autenticación en dos pasos. Solo te lo pediremos una vez.
          Para futuros accesos, te enviaremos un código de verificación a ese
          número.
        </p>
      )}
      <Input
        type={recoveryCode ? "text" : "tel"}
        value={inputValue}
        onChange={(e) => setInputValue(e.target.value)}
        placeholder={
          recoveryCode
            ? "Introduce el código"
            : "Introduce tu número telefónico"
        }
      />
    </Modal>
  );
}

export default PhoneNumberModal;